import { render, staticRenderFns } from "./DataCenterLoading.vue?vue&type=template&id=af59ce8e"
import script from "./DataCenterLoading.vue?vue&type=script&lang=js"
export * from "./DataCenterLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports